import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MenuIcon(props: IconProps) {
    return <Icon {...props} iconKey={"menu"}/>
}
